import * as React from 'react';

import { AddNewCardContainer } from '../AddNewCard';
import { StickyScrollBtnContainer, useToggleStickyScrollBtn } from '../StickyScrollBtn';

import { HeroBannerLayout } from '../../components/HeroBanner';
import { PageLayout } from '../../components/PageLayout';
import { Advantages } from '../../components/Advantages';
import { Analytics } from '../../components/Analytics';

import { smoothScrollIntoView } from '@cian/valuation-utils-component';

export const PageContainer: React.FC = () => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const buttonRef = React.useRef<HTMLDivElement>(null);

  useToggleStickyScrollBtn(buttonRef);

  const scrollToFilters = React.useCallback(() => {
    smoothScrollIntoView(containerRef.current as HTMLDivElement);
  }, []);

  return (
    <>
      <HeroBannerLayout>
        <AddNewCardContainer containerRef={containerRef} buttonRef={buttonRef} />
      </HeroBannerLayout>

      <PageLayout>
        <Advantages />
        <Analytics />
      </PageLayout>

      <StickyScrollBtnContainer scrollToFilters={scrollToFilters} />
    </>
  );
};
